import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { checklistService } from './services/checklist-service';
import type { Checklist } from './types/checklist.types';
import ChecklistCompleteForm from './components/checklist-complete-form';
import { useTenancy } from '@/contexts/TenancyContext';

export default function ChecklistCompletePage() {
  const { id } = useParams<{ id: string }>();
  const [checklist, setChecklist] = useState<Checklist | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { activeTenancy } = useTenancy();

  // Use tenancy context for tenantId (matches rest of app)
  // Must use the hook, not require
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // const { activeTenancy } = require('@/contexts/TenancyContext'); // Remove this line
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // const { activeTenancy } = useTenancy();
  // Instead, import and call useTenancy as a hook:
  // import { useTenancy } from '@/contexts/TenancyContext';
  // ...
  // const { activeTenancy } = useTenancy();
  // For now, fallback to localStorage if context missing
  const tenantId = activeTenancy?.id || '';
  useEffect(() => {
    if (!id || !tenantId) return;
    setLoading(true);
    checklistService.getChecklist(id, tenantId)
      .then(setChecklist)
      .catch(err => setError(err.message || 'Failed to load checklist'))
      .finally(() => setLoading(false));
  }, [id, tenantId]);

  if (!id) return <div style={{ padding: 32 }}>No checklist ID provided.</div>;
  if (!tenantId) return <div style={{ padding: 32 }}>No tenant selected.</div>;
  if (loading) return <div style={{ padding: 32 }}>Loading checklist...</div>;
  if (error) return <div style={{ padding: 32, color: 'red' }}>{error}</div>;
  if (!checklist) return <div style={{ padding: 32 }}>Checklist not found.</div>;

  return (
    <div style={{ padding: 32 }}>
      <ChecklistCompleteForm
        checklist={checklist}
        onSubmit={values => {
          // TODO: Implement submit logic (update Firestore, mark as completed, etc.)
          // For now, just log
          console.log('Checklist submitted:', values);
        }}
      />
    </div>
  );
}
